import { useDispatch } from "react-redux";

export const sectionsByCompany = [
  { section: '19', company: 85 },
  { section: '8', company: 85 },
  { section: '62', company: 85 },
  { section: '12', company: 88 }
];

export const verifyDateExpires = (date) => {
  const mes = date.split("/")[0] - 1;
  const anio = "20" + date.split("/")[1];
  return new Date(anio, mes, 1) >= new Date();
};

// export const handleKeyDown = (e) => {
//   const key = e.key;
//   const numerKeyCode = (key >= '0' && key <= '9');
//   const numerE = (key === 'e' || key === 'E');
//   const specialKey = ['Enter', 'Tab'].includes(key);
//   if (!numerKeyCode && specialKey && numerE) {
//     e.preventDefault();
//   }
// };

export const handleKeyDown = (e) => {
  const key = e.key;
  const numerKeyCode = (key >= '0' && key <= '9');
  const specialKeys = ['Enter'];
  if (key === 'Backspace' || key === 'Tab' || (e.ctrlKey || e.metaKey) && (key === 'v' || key === 'V')) {
    return;
  }
  if ((key === 'e' || key === 'E' || specialKeys.includes(key) || !numerKeyCode)) {
    e.preventDefault();
  }
};


export const handleKeyDown2 = (e) => {
  const key = e.key;
  const specialKey = ['Enter'];
  if (key === 'Backspace') {
    return;
  }
  if (specialKey.includes(key)) {
    e.preventDefault();
  }
};

export function validarFecha(fechaStr) {
  // Verificar si la fecha tiene el formato dd/mm/aaaa
  const dateRegex = /^\d{2}\/\d{2}\/\d{4}$/;
  if (!dateRegex.test(fechaStr)) {
    return false;
  }
  // Convertir la cadena de texto en un objeto de fecha
  const fecha = new Date(fechaStr.split("/").reverse().join("-"));
  const fechaActual = new Date();
  // Si la fecha es mayor de edad (18 años)
  const mayorDeEdad = fechaActual.getFullYear() - fecha.getFullYear() >= 18;
  //Si la fecha es mayor que 1800
  const mayorDe1810 = fecha.getFullYear() > 1810;
  // Comprobar todas las condiciones
  return mayorDeEdad && mayorDe1810;
};


export function mayorSetenta(fechaStr) {
  // Verificar si la fecha tiene el formato dd/mm/aaaa
  const dateRegex = /^\d{2}\/\d{2}\/\d{4}$/;
  if (!dateRegex.test(fechaStr)) {
    return false;
  }
  // Convertir la cadena de texto en un objeto de fecha
  const fecha = new Date(fechaStr.split("/").reverse().join("-"));
  const fechaActual = new Date();
  const mayorDeSetenta = fechaActual.getFullYear() - fecha.getFullYear() >= 70;

  return mayorDeSetenta;
}

export function isElderlyDate(dateString) {
  const date = new Date(dateString.split("/").reverse().join("-"));
  const currentYear = new Date().getFullYear();
  const elderlyYear = 1800;
  return date.getFullYear() < elderlyYear;
};

export function strToDate(str) {
  if (!str) return;
  if (typeof str !== 'string') return str;
  // str = str.replaceAll("-", "/");
  str = str.split("/");
  const day = str[0];
  const month = str[1] - 1;
  const year = str[2];
  return new Date(year, month, day)
    .toLocaleDateString('es-ES', { month: "2-digit", day: "2-digit", year: "numeric" });
};


export const relation = [
  { value: 'ab', label: 'Abuelo/a' },
  { value: 'am', label: 'Amiga/o' },
  { value: 'bu', label: 'Business' },
  { value: 'ca', label: 'Compañía Aseguradora' },
  { value: 'cb', label: 'Concubina/o' },
  { value: 'co', label: 'Cuñada/o' },
  { value: 'cy', label: 'Cónyuge' },
  { value: 'ea', label: 'Esposa' },
  { value: 'eo', label: 'Esposo' },
  { value: 'ep', label: 'Esposa/o' },
  { value: 'ey', label: 'Ex-conyuge' },
  { value: 'h', label: 'Hija/o' },
  { value: 'ha', label: 'Hermana/o' },
  { value: 'hj', label: 'Hijastra/o' },
  { value: 'ho', label: 'Hermanastra/o' },
  { value: 'ma', label: 'Madre' },
  { value: 'ni', label: 'Nieta/o' },
  { value: 'nu', label: 'Nuera' },
  { value: 'o', label: 'Otro' },
  { value: 'pa', label: 'Padre' },
  { value: 'pr', label: 'Prima/o' },
  { value: 'sr', label: 'Sin relación' },
  { value: 'ss', label: 'Sobrino/a' },
];

export const rotateDate = (date) => {
  const day = date.split('/')[0];
  const month = date.split('/')[1];
  const year = date.split('/')[2];
  return month + '/' + day + '/' + year;
};

export const titleProducts = [
  { section: '19', title: "Bolso protegido" },
  { section: '62', title: "Empleo protegido" },
  { section: '12', title: "Accidentes personales" },
  { section: '8', title: "Seguro hogar" },
  { section: '159', title: "Notebook protegida" },
  { section: '161', title: "Tecnología portátil" }
];

export const corregirCaracteresRotos = (etiqueta) => {
  const correcciones = {
    'Ã“': 'Ó',
    'Ã‘': 'Ñ',
    'Ã\x81': 'Á',
    'Ã\x89': 'É',
    'Ã\x8D': 'Í',
    'Ã‰': 'É',
    'Ãš': 'Ú',
    'Ð': 'Ñ',
    'ï¿½': 'Ñ',
    'óa': 'ña',
    'ÓA': 'ÑA',
    'ói': 'ñi',
    'ÓI': 'ÑI',
    // Agrega más correcciones según sea necesario
  };

  for (const caracterIncorrecto in correcciones) {
    const correccion = correcciones[caracterIncorrecto];
    const expresionRegular = new RegExp(caracterIncorrecto, 'g');
    etiqueta = etiqueta.replace(expresionRegular, correccion);
  }

  return etiqueta;
};

export const COMPANY_BBVA = 34;

export const CODEMP_MUSIMUNDO = [2, 52];

export const CODEMP_CREDITO_ARGENTINO = [1, 51];
